import { CollectionsBookmarkOutlined } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import { useAppHomeStore, steps } from 'store/appHomeStore';

export const SubjectSwitch = ({ setOpen, allowCollections = false }) => {
  const { setCurrentStep } = useAppHomeStore();

  return (
    <Box
      sx={{
        minHeight: '100%',
        minWidth: '100%',
        display: 'grid',
        padding: 2,
      }}>
      <Typography
        className="modal-title-selection"
        component="div"
        sx={{ paddingRight: '30px', maxWidth: '592px' }}>
        Escolha qual tipo de item que deseja adicionar na listagem de vídeos ou
        {allowCollections ? ' séries ou coleções' : ' séries'} relacionadas
      </Typography>
      <br />
      <Grid
        container
        spacing={2}
        style={{ display: 'flex', paddingLeft: 15, justifySelf: 'center' }}
        maxWidth={allowCollections ? 900 : 600}>
        <Grid item xs={allowCollections ? 4 : 6} style={{ padding: '5px' }}>
          <div
            style={{
              boxShadow: '0px 4px 18px 0px rgba(75, 70, 92, 0.10)',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              height: '280px',
              borderRadius: 6,
              background: 'var(rgba(255, 255, 255, 1), #FFF)',
              cursor: 'pointer',
            }}
            onClick={() => {
              setCurrentStep(steps.video);
              setOpen(false);
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="66"
              height="58"
              viewBox="0 0 66 58"
              fill="none"
              className="svg-scale">
              <path
                d="M57.7276 0.289795C62.2353 0.289795 65.9702 4.02473 65.9702 8.53241V49.7455C65.9702 54.382 62.2353 57.9881 57.7276 57.9881H8.27191C3.63544 57.9881 0.0292969 54.382 0.0292969 49.7455V8.53241C0.0292969 4.02473 3.63544 0.289795 8.27191 0.289795H57.7276ZM14.4539 51.8061V40.4725H6.21126V49.7455C6.21126 50.9046 7.11279 51.8061 8.27191 51.8061H14.4539ZM14.4539 34.2906V23.9873H6.21126V34.2906H14.4539ZM14.4539 17.8054V6.47176H8.27191C7.11279 6.47176 6.21126 7.50208 6.21126 8.53241V17.8054H14.4539ZM45.3637 51.8061V32.2299H20.6358V51.8061H45.3637ZM45.3637 26.048V6.47176H20.6358V26.048H45.3637ZM59.7883 49.7455V40.4725H51.5456V51.8061H57.7276C58.7579 51.8061 59.7883 50.9046 59.7883 49.7455ZM59.7883 34.2906V23.9873H51.5456V34.2906H59.7883ZM59.7883 17.8054V8.53241C59.7883 7.50208 58.7579 6.47176 57.7276 6.47176H51.5456V17.8054H59.7883Z"
                fill="#667085"
              />
            </svg>
            <h6 className="svg-modal-title">Vídeo</h6>
          </div>
        </Grid>
        <Grid item xs={allowCollections ? 4 : 6} style={{ padding: '5px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              height: '280px',
              boxShadow: '0px 4px 18px 0px rgba(75, 70, 92, 0.10)',
              borderRadius: 6,
              background: '#FFF',
              cursor: 'pointer',
            }}
            onClick={() => {
              setCurrentStep(steps.series);
              setOpen(false);
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="78"
              height="65"
              viewBox="0 0 78 65"
              fill="none"
              className="svg-scale">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.4099 0.35141C49.8948 0.35141 64.0718 14.7127 64.0718 32.4334C64.0718 39.8431 61.5891 46.6687 57.426 52.101C58.8463 52.7309 60.2139 53.6967 61.6079 54.6816C65.0099 57.0866 68.6493 59.6558 74.7074 53.6394L77.2542 56.262C69.0411 64.4238 64.1283 60.9537 59.5358 57.7088C57.8932 56.5483 56.3033 55.426 54.5175 55.4031C48.8135 61.0415 41.0149 64.5154 32.4175 64.5154C14.9213 64.5116 0.748047 50.1503 0.748047 32.4334C0.748047 14.7165 14.9213 0.35141 32.4099 0.35141ZM32.4099 28.1273C34.7571 28.1273 36.6559 30.0551 36.6559 32.4296C36.6559 34.804 34.7533 36.7319 32.4099 36.7319C30.0666 36.7319 28.164 34.804 28.164 32.4296C28.164 30.0551 30.0666 28.1273 32.4099 28.1273ZM8.37342 18.3699C10.4681 14.6936 15.1059 13.4339 18.734 15.5564C22.3621 17.6789 23.6053 22.3782 21.5106 26.0544C19.4159 29.7306 14.7781 30.9904 11.1501 28.8679C7.52197 26.7454 6.27871 22.0461 8.37342 18.3699ZM8.37342 46.4931C6.27871 42.8169 7.52197 38.1176 11.1501 35.9951C14.7781 33.8726 19.4159 35.1323 21.5106 38.8086C23.6053 42.4848 22.3621 47.1841 18.734 49.3066C15.1059 51.4291 10.4681 50.1693 8.37342 46.4931ZM32.4099 60.5529C28.2205 60.5529 24.826 57.1133 24.826 52.8683C24.826 48.6233 28.2205 45.1837 32.4099 45.1837C36.5994 45.1837 39.9939 48.6233 39.9939 52.8683C39.9939 57.1133 36.5994 60.5529 32.4099 60.5529ZM56.4464 46.4931C54.3517 50.1693 49.714 51.4291 46.0859 49.3066C42.4578 47.1841 41.2145 42.4848 43.3092 38.8086C45.404 35.1323 50.0417 33.8726 53.6698 35.9951C57.2979 38.1176 58.5412 42.8169 56.4464 46.4931ZM56.4464 18.3699C58.5412 22.0461 57.2979 26.7454 53.6698 28.8679C50.0417 30.9904 45.404 29.7306 43.3092 26.0544C41.2145 22.3782 42.4578 17.6789 46.0859 15.5564C49.714 13.4339 54.3517 14.6936 56.4464 18.3699ZM32.4099 4.31012C36.5994 4.31012 39.9939 7.74966 39.9939 11.9947C39.9939 16.2397 36.5994 19.6792 32.4099 19.6792C28.2205 19.6792 24.826 16.2397 24.826 11.9947C24.826 7.74966 28.2205 4.31012 32.4099 4.31012Z"
                fill="#6F6B7D"
              />
            </svg>
            <h6 className="svg-modal-title">Série</h6>
          </div>
        </Grid>
        {allowCollections && (
          <Grid item xs={4} style={{ padding: '5px' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                height: '280px',
                boxShadow: '0px 4px 18px 0px rgba(75, 70, 92, 0.10)',
                borderRadius: 6,
                background: '#FFF',
                cursor: 'pointer',
              }}
              onClick={() => {
                setCurrentStep(steps.collection);
                setOpen(false);
              }}>
              <CollectionsBookmarkOutlined
                className="svg-scale"
                sx={{ color: '#6F6B7D', fontSize: 64 }}
              />
              <h6 className="svg-modal-title">Coleção</h6>
            </div>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
